import { h } from 'preact';
import Store from 'store/store';
import { Modal, showModal } from 'utils/modal';
import { post } from 'utils/api';

import Button from 'components/button/button';
import HelpTooltip from 'components/tooltip/helpTooltip';

import s from 'components/userSettings/userSettings.sss';

export default class UserSettings extends Modal {
	s = s;

	constructor(props) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		super.componentDidMount?.();
		this.base.querySelector('input[name="name"]').value = this.props.user?.name || '';
		// this.base.querySelector('input[name="allow-emails"]').checked = !!this.props.user?.can_be_emailed;
	}

	async onSubmit(e) {
		e.preventDefault();
		if (this.state.saving) return;

		if (e.submitter?.value === 'CANCEL') {
			return this.base.close();
		}

		const data = Object.fromEntries(new FormData(this.base.querySelector('form')));
		const newData = {
			name: data.name,
			// can_be_emailed: !!data['allow-emails']
		};
		const hasChange = ['name', 'can_be_emailed'].some(key => newData[key] !== this.props.user[key]);
		if (!hasChange) {
			return this.base.close();
		}

		this.setState({ saving: true, error: false });
		try {
			const results = await post('/users/user-settings', newData);
			// Should we just return the user object and let the caller update the store?
			Store.get().set({ user: results.data });
			this.base.close();
		} catch {
			this.setState({ saving: false, error: 'We could not save your details. Please try again later.' });
		}
	}

	renderTitle() {
		return (
			<div class={s.header}>
				<h2 class={s.title}>User settings</h2>
				<p>Adjust settings related to your account</p>
			</div>
		);
	}

	renderContent() {
		return (
			<div class={s.content}>
				<label>
					<span>Name</span>
					<input type="text" name="name" required />
				</label>
				<label for="user-settings-email">
					<span>Email <HelpTooltip>Contact us to change your email</HelpTooltip></span>
					<input type="email" name="email" id="user-settings-email" value={this.props.user?.email || ''} disabled />
				</label>
				{/* <label class={s.checkboxWrapper}>
					<input type="checkbox" name="allow-emails" /> Get notifications by email
				</label> */}
				<div class={s.error}>{this.state.error}</div>
			</div>
		);
	}

	renderActions() {
		return (
			<div class={s.actions}>
				<Button type="submit" value="CANCEL">Cancel</Button>
				<Button primary type="submit" value="OK" disabled={this.state.saving}>Save changes</Button>
			</div>
		);
	}
}

export async function showUserSettings(user = Store.get().user) {
	await showModal(UserSettings, { user });
}